import { invoke } from "@tauri-apps/api/tauri";

export type SqlParam = string | number | boolean | null;

export async function initDb(): Promise<void> {
  await invoke("sqlite_init");
}

export async function query<T = Record<string, unknown>>(
  sql: string,
  params: SqlParam[] = []
): Promise<T[]> {
  const rows = (await invoke("sqlite_query", { sql, params })) as unknown;
  return rows as T[];
}

export async function execute(
  sql: string,
  params: SqlParam[] = []
): Promise<number> {
  const affected = (await invoke("sqlite_execute", {
    sql,
    params,
  })) as unknown;
  return affected as number;
}

export const cache = {
  async upsertProducto(p: {
    id: number;
    sku: string;
    barcode: string | null;
    nombre: string;
    precio: number;
    stock: number;
    json: string;
  }) {
    await execute(
      `INSERT INTO catalogo_cache (id, sku, barcode, nombre, precio, stock, json)
       VALUES (?, ?, ?, ?, ?, ?, ?)
       ON CONFLICT(id) DO UPDATE SET
         sku=excluded.sku,
         barcode=excluded.barcode,
         nombre=excluded.nombre,
         precio=excluded.precio,
         stock=excluded.stock,
         json=excluded.json`,
      [p.id, p.sku, p.barcode, p.nombre, p.precio, p.stock, p.json]
    );
  },
  async enqueueVenta(uuid: string, payload: unknown) {
    await execute(
      `INSERT INTO ventas_outbox (id, payload_json, created_at, attempts)
       VALUES (?, ?, strftime('%s','now'), 0)`,
      [uuid, JSON.stringify(payload)]
    );
  },
};
